import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postHostUserImage = async (payload) => {
  const { data } = await SigliveServiceV1({ method: 'POST', url: '/productivity-host/briefs/uploads/images', data: payload });

  return data;
};

export default postHostUserImage;
